export type BasicDeliveryZoneCandidate = {
  id: number;
  name: string | null;
  type: string;
  default: boolean;
  systemDefinedType: string | null;
};

export const selectBasicDeliveryDefaults = <
  T extends BasicDeliveryZoneCandidate,
>(
  zones: readonly T[],
) => {
  const ordered = zones.toSorted((left, right) => left.id - right.id);
  const direct = ordered.filter(
    (zone) =>
      zone.type === "direct" &&
      !zone.default &&
      zone.systemDefinedType === null,
  );
  return {
    local: direct.find((zone) => zone.name === "Local") ?? direct[0],
    nationwide: ordered.find(
      (zone) =>
        zone.type === "thirdParty" &&
        zone.default &&
        zone.systemDefinedType === null,
    ),
  };
};
